import React, { FC, useState } from 'react'
import { truncateString } from '../../utils/sliceString'
import styles from './CompanyPageDescription.module.css'
import arrowRightGray from '../../assets/icons/arrowRightGray.svg'

export type CompanyPageDescriptionPropsType = {
  text: string
}

const CompanyPageDescription: FC<CompanyPageDescriptionPropsType> = ({ text }) => {
  return (
    <div className={styles.descriptionBlock}>
      <h2 className={styles.title}>Описание:</h2>
      <div className={styles.container}>
        <div className={styles.descriptionText}>{text}</div>
      </div>
    </div>
  )
}

export default CompanyPageDescription
